module.exports = __webpack_public_path__ + "static/media/back.67702653.webp";